import React from 'react';
import menuLight from "../../../assets/menuLight.svg";
import menuDark from "../../../assets/menuDark.svg";
import {useAppStore} from "../../../GlobalStore/GlobalStore.ts";

interface MenuProps {
    buttonRef: any;
}

const Menu: React.FC<MenuProps> = ({ buttonRef }) => {
    const settingsObj = useAppStore((state: any) => state.settingsObj);
    const { theme } = settingsObj;
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment } = environmentObj;
    const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);

    const handleMenuClick = () => {
        setDynamicStateObj({isMenuOpen: !dynamicStateObj.isMenuOpen});
    };

    const getMenuStyles = () => {
        const styles = [];

        if (environment.includes("jetbrains")) {
            styles.push("ml-auto mr-3");
        } else if (environment === "chrome") {
            styles.push("ml-auto mr-5");
        } else if (environment === 'vscode') {
            styles.push("ml-3");
        } else {
            styles.push("ml-5");
        }

        return styles.join(' ');
    };
    const menuStyles = getMenuStyles();

    return (
        <button
            className={`h-6 w-6 cursor-pointer ${menuStyles}`}
            onClick={handleMenuClick}
        >
            <img
                ref={buttonRef}
                src={`${theme === 'dark' ? menuLight : menuDark}`}
                alt="Menu"
            />
        </button>

    );
};

export default Menu;
